module.exports = __webpack_public_path__ + "static/media/hydro.f0e71207.jpg";